import React from "react";
import plot from "./plot.svg"

const Footer = () => {
    return (
        <div id="about" className="aboutsection">
            <h3 className="mainHeader">CRIME COUNT PREDICTOR</h3>
            <p>The dataset analyzed reflects arrest incidents in the City of 
                Los Angeles dating back to 2010. <br /> 
                The model found is <code> 𝑦 = −8323.53𝑥 + 16900443.58</code> with R-squared score 0.940
            </p>
            
            <div className="plot"> 
                <img src={plot} /> 
                <p>Linear Fitting of Crime Count</p>
            </div>
        </div>
    )
};

export default Footer;